/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contributions_OneInputs */

const en_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 contribution`)
};

const ar_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساهمة واحدة`)
};

const bn_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`১টি কন্ট্রিবিউশন`)
};

const de_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Beitrag`)
};

const es_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 contribución`)
};

const fr_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 contribution`)
};

const pt_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 contribuição`)
};

const zh_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 次贡献`)
};

const tr_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 katkı`)
};

const ru_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 вклад`)
};

const pl_contributions_one = /** @type {(inputs: Contributions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 kontrybucja`)
};

/**
* | output |
* | --- |
* | "1 contribution" |
*
* @param {Contributions_OneInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_one = /** @type {((inputs?: Contributions_OneInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_OneInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_one(inputs)
	if (locale === "bn") return bn_contributions_one(inputs)
	if (locale === "de") return de_contributions_one(inputs)
	if (locale === "es") return es_contributions_one(inputs)
	if (locale === "fr") return fr_contributions_one(inputs)
	if (locale === "pt") return pt_contributions_one(inputs)
	if (locale === "zh") return zh_contributions_one(inputs)
	if (locale === "tr") return tr_contributions_one(inputs)
	if (locale === "ru") return ru_contributions_one(inputs)
	if (locale === "pl") return pl_contributions_one(inputs)
	return en_contributions_one(inputs)
});